module.exports = __webpack_public_path__ + "media/icons/opony-felgi-menu@3x-4b9f79a9.svg";